<template>
  <v-app>
    <header>
      <div class="header-inner">
        <router-link to="/" class="logo-section" @click.native="scrollToTop">
          <img :src="logoSvg" alt="Origami Skin Logo" />
          <span class="brand-name">ORIGAMI SKIN</span>
        </router-link>
        <nav>
          <router-link to="/blog" class="nav-link">Blog</router-link>
          
          <button 
            @click="toggleLanguage" 
            class="lang-btn"
          >
            {{ currentLang === 'ko' ? 'EN' : 'KO' }}
          </button>
        </nav>
      </div>
    </header>

    <v-main class="main-content">
      <router-view />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Footer,
  },
  data() {
    return {
      logoSvg: '/assets/logo/logo.svg'
    };
  },
  computed: {
    currentLang() {
      return this.$store.getters.language;
    }
  },
  created() {
    // Only init if not already persisted (check if store has non-default value logic if needed)
    // But simplest is: if localStorage is empty, run init.
    // However, vuex-persistedstate runs automatically.
    // If we want to respect browser default on FIRST visit, we should check if 'language' is in localStorage.
    
    // For now, let's keep it simple: 
    // If state is 'en' (default), we might want to check browser. 
    // BUT 'en' is a valid choice.
    // A better way is checking if persisted state exists.
    // Let's rely on manual toggle mainly, and simple init logic.
    
    if (!localStorage.getItem("vuex")) {
      this.$store.dispatch("initLanguage");
    }
  },
  methods: {
    toggleLanguage() {
      const newLang = this.currentLang === 'ko' ? 'en' : 'ko';
      this.$store.dispatch("setLanguage", newLang);
    },
    scrollToTop() {
      if (this.$route.path === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }
};
</script>

<style>
.v-application {
  font-family: "Lato", "Noto Sans KR", sans-serif !important;
}
html, body {
  background-color: #0f0f1a;
}
.font-serif {
  font-family: "Playfair Display", serif !important;
}
.font-sans {
  font-family: "Lato", sans-serif !important;
}

/* Header Styles */
header {
  position: fixed;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  z-index: 50;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.header-inner {
  width: 100%;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
}

.logo-section img {
  height: 2.5rem; /* Smaller logo */
  width: auto;
}

.brand-name {
  font-family: 'Playfair Display', serif;
  font-size: 1.25rem; /* Smaller, fixed size */
  white-space: nowrap;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #1a1a40;
}

.nav-link {
  font-weight: 600;
  color: #1a1a40;
  text-decoration: none;
  font-size: 1rem;
  margin-left: 1rem;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #c5a059;
}

.lang-btn {
  margin-left: 1.5rem;
  font-weight: 700;
  font-size: 0.9rem;
  color: #1a1a40;
  border: 1px solid #1a1a40;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.lang-btn:hover {
  background: #1a1a40;
  color: white;
}

/* Add padding to main content because header is fixed */
.main-content {
  padding-top: 80px !important;
}

.main-content .v-main__wrap {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 80px);
}

.main-content footer {
  margin-top: auto;
}

/* Mobile Header Adjustments */
@media (max-width: 600px) {
  .header-inner {
    padding: 0.75rem 1rem;
  }

  .logo-section img {
    height: 1.75rem;
  }

  .brand-name {
    font-size: 1rem;
    letter-spacing: 0;
  }

  .nav-link {
    margin-left: 0.5rem;
    font-size: 0.9rem;
  }

  .lang-btn {
    margin-left: 0.75rem;
    padding: 0.2rem 0.5rem;
    font-size: 0.8rem;
  }
}
</style>
